import { logger } from "./LogUtils";
import { isNullOrEmpty } from "./StringUtils";

const emptyDemoConfig = { demos: {} };

/**
 * Fetches demo config
 */
export function getDemoConfig() {
  var demoConfigJSON = localStorage.getItem("demoConfig");

  if (isNullOrEmpty(demoConfigJSON)) {
    demoConfigJSON = JSON.stringify(emptyDemoConfig, null, 2);
  }

  return JSON.parse(demoConfigJSON);
}

/**
 * Updates the preferred variant for a demo
 */
export function setPreferredVariant(
  demoId: string,
  language: string,
  vertical: string
) {
  try {
    const demoConfig = getDemoConfig();

    // TODO handle existing other demo config data here
    demoConfig.demos[demoId] = {
      preferredVariant: {
        language: language,
        vertical: vertical,
      },
    };

    localStorage.setItem("demoConfig", JSON.stringify(demoConfig, null, 2));
  } catch (error) {
    logger.error(
      "Preferences.setPreferredVariant() failed to update demo preferences",
      error
    );
    throw error;
  }
}

/**
 * Clears the preferred variant for a demo
 */
export function clearPreferredVariant(demoId: string) {
  try {
    const demoConfig = getDemoConfig();

    // TODO handle existing other demo config data here
    demoConfig.demos[demoId] = undefined;

    localStorage.setItem("demoConfig", JSON.stringify(demoConfig, null, 2));
  } catch (error) {
    logger.error(
      "Preferences.clearPreferredVariant() failed to clear demo preferences",
      error
    );
    throw error;
  }
}

/**
 * Fetches the preferred variant for a demo
 */
export function getPreferredVariant(demoId: string): {
  demoId: string;
  language: string;
  vertical: string;
} {
  try {
    if (isNullOrEmpty(demoId)) {
      throw new Error("Null demo id");
    }

    const demoConfig = getDemoConfig();

    logger.info(`Loaded config: ${JSON.stringify(demoConfig, null, 2)}`);

    if (demoConfig.demos[demoId] === undefined) {
      logger.info(
        "Preferences.getPreferredVariant() no configured preferred variant found"
      );
      return undefined;
    }

    const preferred = demoConfig.demos[demoId].preferredVariant;

    logger.info(
      `Preferences.getPreferredVariant() found preferred variant: ${JSON.stringify(
        preferred,
        null,
        2
      )}`
    );

    return preferred;
  } catch (error) {
    logger.error(
      "Preferences.getPreferredVariant() failed to local preferred variant",
      error
    );
    return undefined;
  }
}

/**
 * Gets the GroupView switcher visibility setting
 */
export function getGroupViewSwitcherEnabled(): boolean {
  try {
    const enabled = localStorage.getItem("groupViewSwitcherEnabled");
    return enabled === "true";
  } catch (error) {
    logger.error("Failed to get GroupView switcher setting", error);
    return false;
  }
}

/**
 * Sets the GroupView switcher visibility setting
 */
export function setGroupViewSwitcherEnabled(enabled: boolean) {
  try {
    localStorage.setItem("groupViewSwitcherEnabled", enabled.toString());
  } catch (error) {
    logger.error("Failed to set GroupView switcher setting", error);
  }
}
